export * from './IconPrint';
export { default as IconPrint } from './IconPrint';
